<template>
  <section class="glass-panel flex flex-col gap-5 rounded-xl p-5">
    <header v-if="title" class="flex items-center justify-between gap-3">
      <h2 class="m-0 text-sm font-semibold text-foreground">
        {{ title }}
      </h2>
      <component :is="icon" v-if="icon" class="size-4.5 shrink-0 text-muted-foreground" />
    </header>

    <slot />

    <footer v-if="$slots.footer" class="mt-auto flex justify-end">
      <slot name="footer" />
    </footer>
  </section>
</template>

<script>
/**
 * Glass card with a title row.
 */
export default {
  name: 'ContentPanel',
  props: {
    title: {
      type: String,
      required: false,
      default: () => '',
    },
    // A lucide icon component.
    icon: {
      type: [ Object, Function ],
      required: false,
      default: () => null,
    },
  },
};
</script>
